import styled from 'styled-components';
import { ModalBody } from '../CommonComponents/OPL/Modal/ModalBody';

export const StyledModalBody = styled(ModalBody)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridGap: 16,
});
